/**
 * "Managing your subscription" — Billing section (ADR-0074).
 * Reconciled from billing.service.ts + billing.resolver.ts (Checkout, Billing
 * Portal, changePlanTier, cancel/reactivate) and billingInvoices in
 * billing.graphql. Payments run on Paddle (ADR-0092 / ADR-0118).
 */
import type { DocPageContent } from '../types';

export const BILLING_SUBSCRIPTION_PAGE: DocPageContent = {
  slug: 'billing/subscription',
  titleKey: 'docs.billing.subscription.title',
  descriptionKey: 'docs.billing.subscription.description',
  blocks: [
    { kind: 'paragraph', textKey: 'docs.billing.subscription.lead' },

    { kind: 'heading', level: 2, id: 'start', textKey: 'docs.billing.subscription.start.heading' },
    { kind: 'paragraph', textKey: 'docs.billing.subscription.start.body' },
    {
      kind: 'steps',
      steps: [
        {
          titleKey: 'docs.billing.subscription.start.step.open.title',
          textKey: 'docs.billing.subscription.start.step.open.text',
        },
        {
          titleKey: 'docs.billing.subscription.start.step.choose.title',
          textKey: 'docs.billing.subscription.start.step.choose.text',
        },
        {
          titleKey: 'docs.billing.subscription.start.step.checkout.title',
          textKey: 'docs.billing.subscription.start.step.checkout.text',
        },
      ],
    },

    {
      kind: 'heading',
      level: 2,
      id: 'change',
      textKey: 'docs.billing.subscription.change.heading',
    },
    { kind: 'paragraph', textKey: 'docs.billing.subscription.change.body' },

    {
      kind: 'heading',
      level: 2,
      id: 'cancel',
      textKey: 'docs.billing.subscription.cancel.heading',
    },
    { kind: 'paragraph', textKey: 'docs.billing.subscription.cancel.body' },

    {
      kind: 'heading',
      level: 2,
      id: 'portal',
      textKey: 'docs.billing.subscription.portal.heading',
    },
    { kind: 'paragraph', textKey: 'docs.billing.subscription.portal.body' },
    {
      kind: 'callout',
      tone: 'note',
      titleKey: 'docs.billing.subscription.portal.note.title',
      textKey: 'docs.billing.subscription.portal.note.body',
    },

    {
      kind: 'heading',
      level: 2,
      id: 'invoices',
      textKey: 'docs.billing.subscription.invoices.heading',
    },
    { kind: 'paragraph', textKey: 'docs.billing.subscription.invoices.body' },
    {
      kind: 'list',
      itemKeys: [
        'docs.billing.subscription.invoices.item.list',
        'docs.billing.subscription.invoices.item.download',
        'docs.billing.subscription.invoices.item.receipts',
      ],
    },

    {
      kind: 'heading',
      level: 2,
      id: 'access',
      textKey: 'docs.billing.subscription.access.heading',
    },
    {
      kind: 'paragraph',
      textKey: 'docs.billing.subscription.access.body',
      links: {
        team: {
          target: { docSlug: 'dashboard/team' },
          labelKey: 'docs.billing.subscription.access.link',
        },
      },
    },

    { kind: 'heading', level: 2, id: 'next', textKey: 'docs.common.nextSteps' },
    {
      kind: 'cardGrid',
      cards: [
        {
          titleKey: 'docs.billing.subscription.next.byok.title',
          textKey: 'docs.billing.subscription.next.byok.text',
          to: { docSlug: 'billing/byok' },
        },
        {
          titleKey: 'docs.billing.subscription.next.limits.title',
          textKey: 'docs.billing.subscription.next.limits.text',
          to: { docSlug: 'billing/limits' },
        },
      ],
    },
  ],
};
